// extracted by mini-css-extract-plugin
export default {"headerAdmin":"login_headerAdmin__o8-7W","admin":"login_admin__qDAfv","formAdmin":"login_formAdmin__zH0X5","input":"login_input__XBNbH"};